import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignOut from "config/signout/SignOut";

function Signout() {
  const isLoggedIn = SignOut();

  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn){
      navigate('/signin');
    }
  }, [navigate, isLoggedIn]);
}

export default Signout;
